import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import brand from './modules/brand'
import game from './modules/game'
import app from './modules/app'
import seo from './modules/seo'

import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user, brand, app, game, seo
  },
  getters,
  plugins: [createPersistedState({
    paths: ['user', 'brand']
  })]
})
export default store
